import { render } from "./FileField.vue?vue&type=template&id=80aebfd2"
import script from "./FileField.vue?vue&type=script&lang=js"
export * from "./FileField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FileField.vue"]])

export default __exports__